import { render, staticRenderFns } from "./AnnualLeaveRequestsShow.vue?vue&type=template&id=0831708b&"
import script from "./AnnualLeaveRequestsShow.vue?vue&type=script&lang=js&"
export * from "./AnnualLeaveRequestsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports